<script setup lang="ts">
import type { ElementsCard } from '@autobid/strapi-integration/rest/components'
import type { Props } from '@autobid/ui/types/components/CardColumnsGroup'
import CardPrimary from '@autobid/ui/components/elements/card/CardPrimary.vue'
import CardSecondary from '@autobid/ui/components/elements/card/CardSecondary.vue'
import { mapTailwindWidthToPercent } from '@autobid/ui/utils/mapTailwindWidthToPercenet'

defineProps<Props>()

function getColumns(cards: ElementsCard[]) {
  return cards
    .reduce((acc: string[], { width }) => {
      return [...acc, mapTailwindWidthToPercent(width?.name)]
    }, [])
    .join(' ')
}
</script>

<template>
  <elements-expander class="my-4 w-full @container" :expander="data.expander">
    <div
      id="card-columns-group"
      class="grid h-max items-stretch justify-center gap-2 px-2"
      :style="{
        gridTemplateColumns: getColumns(data.cards),
      }"
    >
      <component
        :is="card.variant === 'primary' ? CardPrimary : CardSecondary"
        v-for="card of data.cards"
        :key="card.id"
        :card="card"
      />
    </div>
  </elements-expander>
</template>

<style>
@container (max-width: 768px) {
  #card-columns-group {
    grid-template-columns: 1fr !important;
  }
}
</style>
